import MuiStack, { type StackProps } from "@mui/material/Stack";

export type { StackProps };

export const Stack = MuiStack;
